import React from 'react';
import './CircularStatsCards.scss';

interface StatData {
  label: string;
  value: number;
  max: number;
}

interface CircularStatsCardsProps {
  data?: StatData[];
}

const DEFAULT_DATA: StatData[] = [
  { label: 'Total Hours', value: 500, max: 1200 },
  { label: 'Total Reviews', value: 500, max: 1200 },
];

const CircularStatsCards: React.FC<CircularStatsCardsProps> = ({ data = DEFAULT_DATA }) => {
  const CircularChart: React.FC<{ value: number; max: number }> = ({ value, max }) => {
    const percentage = (value / max) * 100;

    return (
      <div className="circular-chart">
        <div
          className="circular-progress"
          style={{
            background: `conic-gradient(#1A92D0 0deg ${percentage * 3.6}deg, #E5E7EB ${percentage * 3.6}deg 360deg)`,
          }}
        >
          <div className="circular-content">
            <span className="circular-value">{value}</span>
            <span className="circular-max">out of {max}</span>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="circular-stats-cards">
      {data.map((item, index) => (
        <div key={index} className="circular-stat-card">
          <span className="circular-stat-label">{item.label}</span>
          <CircularChart value={item.value} max={item.max} />
        </div>
      ))}
    </div>
  );
};

export { CircularStatsCards };
